'use strict';

var _classCallCheck = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var AbortController = require('abort-controller');

var SubscriptionTracker =
/*#__PURE__*/
function () {
  function SubscriptionTracker() {
    _classCallCheck(this, SubscriptionTracker);

    this._subs = new Map();
  }

  _createClass(SubscriptionTracker, [{
    key: "subscribe",
    value: function subscribe(topic, handler, signal) {
      var _this = this;

      var topicSubs = this._subs.get(topic) || [];

      if (topicSubs.find(function (s) {
        return s.handler === handler;
      })) {
        throw new Error("Already subscribed to ".concat(topic, " with this handler"));
      } // Create controller so a call to unsubscribe can cancel the request


      var controller = new AbortController();

      this._subs.set(topic, [{
        handler: handler,
        controller: controller
      }].concat(topicSubs)); // If there is an external signal, forward the abort event


      if (signal) {
        signal.addEventListener('abort', function () {
          return _this.unsubscribe(topic, handler);
        });
      }

      return controller.signal;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(topic, handler) {
      var subs = this._subs.get(topic) || [];
      var unsubs;

      if (handler) {
        this._subs.set(topic, subs.filter(function (s) {
          return s.handler !== handler;
        }));

        unsubs = subs.filter(function (s) {
          return s.handler === handler;
        });
      } else {
        this._subs.set(topic, []);

        unsubs = subs;
      }

      unsubs.forEach(function (s) {
        return s.controller.abort();
      });
    }
  }], [{
    key: "singleton",
    value: function singleton() {
      if (SubscriptionTracker.instance) return SubscriptionTracker.instance;
      SubscriptionTracker.instance = new SubscriptionTracker();
      return SubscriptionTracker.instance;
    }
  }]);

  return SubscriptionTracker;
}();

SubscriptionTracker.instance = null;
module.exports = SubscriptionTracker;